import classnames from 'classnames';
import type React from 'react';
import styles from './ButtonGroup.module.scss';
export const ButtonGroup = ({
  className,
  children,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={classnames(styles.host, className)} {...props} data-sentry-component="ButtonGroup" data-sentry-source-file="index.tsx">
    {children}
  </div>;